Vue.component('stat-page-element', {
	template: '<div class="stat-page"><navbar-element :title="title" :showGridButton="showGridButton"/><statSelector /><main class="stat-page-content"><slot/></main></div>',
	props: {
		title: {
			type: String,
			default: ""
		},
		showGridButton: {
			type: Boolean,
			default: true
		}
	},
});
